import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] bg-[#F5EFE0] flex items-center justify-center px-6 text-center">
      <div>
        <div className="font-display text-[10rem] sm:text-[14rem] font-black text-[#2D5F3F] leading-none">404</div>
        <h1 className="font-display text-3xl sm:text-5xl font-black uppercase text-[#0A0A0A]">Off Sides</h1>
        <p className="mt-4 text-black/75">That page isn&apos;t on the roster.</p>
        <Link
          to="/"
          data-testid="not-found-home"
          className="mt-8 inline-flex bg-[#2D5F3F] hover:bg-[#1B4332] text-[#FDFBF7] font-display uppercase tracking-wider font-extrabold px-6 py-3 transition-colors"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
